// Map configuration utilities for consistent tile layer setup
import L from 'leaflet';

// Primary tile layer configuration
export const getPrimaryTileLayer = () => {
  return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap contributors',
    maxZoom: 19,
    subdomains: ['a', 'b', 'c']
  });
};

// Fallback tile layer configurations
export const getFallbackTileLayers = () => [
  // CartoDB Positron (light theme)
  L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
    attribution: '© OpenStreetMap contributors © CARTO',
    subdomains: 'abcd',
    maxZoom: 20
  }),
  
  // CartoDB Dark Matter (dark theme)
  L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
    attribution: '© OpenStreetMap contributors © CARTO',
    subdomains: 'abcd',
    maxZoom: 20
  }),
  
  // Stamen Terrain
  L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}{r}.png', {
    attribution: 'Map tiles by Stamen Design, CC BY 3.0 — Map data © OpenStreetMap contributors',
    subdomains: 'abcd',
    maxZoom: 18
  })
];

// Create a robust tile layer with fallbacks
export const createRobustTileLayer = (map) => {
  const primaryLayer = getPrimaryTileLayer();
  const fallbackLayers = getFallbackTileLayers();
  
  // Add primary layer
  primaryLayer.addTo(map);
  
  // Set up fallback mechanism
  primaryLayer.on('tileerror', (error) => {
    console.warn('Primary tile layer failed, trying fallback:', error);
    
    // Remove primary layer
    map.removeLayer(primaryLayer);
    
    // Try fallback layers
    let fallbackIndex = 0;
    const tryNextFallback = () => {
      if (fallbackIndex < fallbackLayers.length) {
        const fallbackLayer = fallbackLayers[fallbackIndex];
        fallbackLayer.addTo(map);
        
        fallbackLayer.on('tileerror', () => {
          console.warn(`Fallback layer ${fallbackIndex} failed, trying next...`);
          map.removeLayer(fallbackLayer);
          fallbackIndex++;
          tryNextFallback();
        });
      } else {
        console.error('All tile layers failed to load');
        // Show error message on map
        const errorDiv = document.createElement('div');
        errorDiv.innerHTML = `
          <div style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(255, 255, 255, 0.9);
            padding: 20px;
            border-radius: 8px;
            text-align: center;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            z-index: 1000;
          ">
            <h3 style="margin: 0 0 10px 0; color: #e53e3e;">Map Loading Error</h3>
            <p style="margin: 0; color: #666;">Unable to load map tiles. Please check your internet connection.</p>
          </div>
        `;
        map.getContainer().appendChild(errorDiv);
      }
    };
    
    tryNextFallback();
  });
  
  return primaryLayer;
};

// React Leaflet tile layer configuration for components
export const getReactLeafletTileLayerProps = () => ({
  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: '© OpenStreetMap contributors',
  maxZoom: 19,
  subdomains: ['a', 'b', 'c']
});

// Alternative tile layer props for fallback
export const getFallbackReactLeafletTileLayerProps = () => ({
  url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
  attribution: '© OpenStreetMap contributors © CARTO',
  subdomains: 'abcd',
  maxZoom: 20
});
